import { useParams } from 'react-router'

function useParam(key: string): string
function useParam(key: string, optional: true): string | undefined
function useParam(key: string, optional: boolean = false) {
  const params = useParams()
  const param = params[key]
  if (!optional && !param) throw new Error(`Param ${key} not found`)

  return param
}

export { useParam }
